import { useQuery } from "@tanstack/react-query";
import queryKey from "../../../enumerations/queryKey";
import { apiGetShare } from "../service";

export const useGetShare = (options) => {
  return useQuery([queryKey.SHARE], () => apiGetShare().then((res) => res.data.data), {
    ...options,
  });
};
